<template>
  <div class="h-view overflow-auto bg-white">
    <div class="mx-4 text-center lg:mx-auto lg:max-w-(--breakpoint-lg)">
      <h3 class="p-4 py-16 text-xl font-semibold">
        Vi vil rekke en stor takk til våre samarbeidspartnere som gjør det mulig å arrangere UL!
      </h3>
      <div class="mb-12 grid grid-cols-2 gap-4 pb-6 sm:grid-cols-3 sm:gap-12 lg:grid-cols-3 lg:gap-24">
        <a
          v-for="sponsor in sponsors"
          :key="sponsor.id"
          :style="{ backgroundImage: `url(${sponsor.image})` }"
          :href="sponsor.link"
          target="_blank"
          rel="noopener noreferrer"
          class="aspect-video w-full bg-cover bg-center shadow-xl transition-all duration-100 hover:scale-105 hover:shadow-2xl"
          :class="[sponsor.link ? '' : '']"
        >
        </a>
      </div>
    </div>
    <PageFooter />
  </div>
</template>

<script setup lang="ts">
import PageFooter from '../components/PageFooter.vue'
import { useSponsorStore } from '../stores/sponsors'

const sponsorStore = useSponsorStore()
const sponsors = sponsorStore.sponsors.toSorted(() => 0.5 - Math.random())
</script>

<style lang="scss"></style>
